module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "big-screen",
    attrs: {
      "id": "bigScreen"
    }
  }, [_c('div', {
    staticClass: "canvas-wrap",
    attrs: {
      "id": "canvasWrap"
    },
    on: {
      "dblclick": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }), _vm._v(" "), (_vm.showMask) ? _c('div', {
    staticClass: "maskDebug"
  }) : _vm._e(), _vm._v(" "), (!_vm.showMask) ? _c('span', {
    staticClass: "fullScreen",
    class: {
      show: !_vm.fullScreen
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doFullScreen.apply(null, arguments)
      }
    }
  }, [_vm._v(_vm._s(!_vm.fullScreen ? "全屏" : "取消全屏"))]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-1e3f5282","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/bigScreenFrontEndWithoutAutoScreen/index.vue
// module id = 931
// module chunks = 1